import { runInAction } from 'mobx';
import { browsingDomainStore } from '../../store';
export const removeSelectedSite = (siteId) => {
    const state = browsingDomainStore.data.selectedSiteIds;
    runInAction(() => state.splice(state.indexOf(siteId), 1));
};
//# sourceMappingURL=remove-selected-site.js.map